import { render, staticRenderFns } from "./MarquesList.vue?vue&type=template&id=cd8b2f34&"
import script from "./MarquesList.vue?vue&type=script&lang=js&"
export * from "./MarquesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports